import { Injectable } from "@angular/core";
import { RestReadServiceBase } from "@definitiv-packages/angular-dba-library";
import { DebitorModelView } from "../../../public-api";

@Injectable({
    providedIn: 'root'
})
export class DebitorViewService extends RestReadServiceBase<DebitorModelView> {
    constructor(
    ) {
        super("DebitorModelView", false);
    }
}